import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve aunque nunca haya hecho ejercicio?',
    a: 'Sí. El Tomo 1 arranca desde cero. Si podés levantarte del suelo, podés hacer este protocolo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de la compra recibís el link de descarga. Acceso en menos de 5 minutos desde cualquier dispositivo.'
  }, {
    q: '¿Necesito equipamiento o gimnasio?',
    a: 'No. Solo el suelo y una silla de comedor. Sin pesas ni membresía.'
  }, {
    q: '¿Funciona si como afuera y tengo vida social?',
    a: 'Sí. El Tomo 3 tiene protocolo para asados, restaurantes y cumpleaños. El Bono 6 es específicamente para los fines de semana.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-88" data-mp="jo9h1zau8zpe">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-89" data-mp="1kngo1h4zamqe">
        ❓ LO QUE MÁS NOS PREGUNTAN
      </motion.h2>

      <div className="space-y-4" data-id="element-90" data-mp="1fqqd18816hbu">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-brand-green/20 rounded-xl overflow-hidden" data-id="element-91" data-mp="11wgwq9a0h0ty" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-92" data-mp="mzq7gsu1x5i2">
              <span className="font-bold text-lg pr-4" data-id="element-93" data-mp="2kvesarny5uir">{faq.q}</span>
              <motion.div animate={{
            rotate: openIndex === i ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="shrink-0 text-brand-green" data-id="element-94" data-mp="2ku3o4qqlakr4">
                <ChevronDown className="w-5 h-5" data-id="element-95" data-mp="38kpwyk8f4926" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-96" data-mp="33n7lon6xhhr0">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-97" data-mp="2yma6mjh7t3tq">
                  <div className="px-6 pb-5 text-gray-400 leading-relaxed" data-id="element-98" data-mp="2pm3vy801kht">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}